import _defineProperty from "/app/workspaces/v_1/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// @ts-check
import { Data } from '@symbiotejs/symbiote';
import { Block } from '../../../abstract/Block.js';
const CSS_CFG_CTX_NAME = '--cfg-ctx-name';
export class CloudImageEditorBase extends Block {
  /**
   * @private
   * @returns {string}
   */
  get cfgCssCtxName() {
    return this.getCssData(CSS_CFG_CTX_NAME, true);
  }

  /** @private */
  get cfgCtxName() {
    var _this$getAttribute;
    const ctxName = ((_this$getAttribute = this.getAttribute('ctx-name')) === null || _this$getAttribute === void 0 ? void 0 : _this$getAttribute.trim()) || this.cfgCssCtxName || this.__cachedCfgCtxName;
    if (!ctxName) {
      throw new Error("ctx-name attribute is required for ".concat(this.constructor.name));
    }
    /**
     * Cache last ctx name to be able to access context when element becames disconnected
     *
     * @type {String}
     */
    this.__cachedCfgCtxName = ctxName;
    return ctxName;
  }
  connectedCallback() {
    if (!this.connectedOnce) {
      var _this$getAttribute2;
      const ctxName = (_this$getAttribute2 = this.getAttribute('ctx-name')) === null || _this$getAttribute2 === void 0 ? void 0 : _this$getAttribute2.trim();
      if (ctxName) {
        this.style.setProperty(CSS_CFG_CTX_NAME, "'".concat(ctxName, "'"));
      }
    }
    super.connectedCallback();
  }

  /**
   * Resolve cfg from context passed with ctx-name attribute
   *
   * @param {String} prop
   * @returns {any}
   * @protected
   */
  parseCfgProp(prop) {
    const parsed = _objectSpread(_objectSpread({}, super.parseCfgProp(prop)), {}, {
      ctx: Data.getCtx(this.cfgCtxName)
    });
    return parsed;
  }
  get debugCtxName() {
    return this.cfgCtxName;
  }
}